import { motion } from "framer-motion";
import { techStack } from "@/mocks/serra";

const LABELS: Record<string, string> = {
  react: "React",
  nodedotjs: "Node.js",
  typescript: "TypeScript",
  nextdotjs: "Next.js",
  flutter: "Flutter",
  supabase: "Supabase",
  firebase: "Firebase",
  amazonaws: "AWS",
  docker: "Docker",
};

// Simple Icons doesn't ship an AWS mark (trademark restriction), so this one uses a local asset instead of the CDN.
const LOCAL_ICONS: Record<string, string> = {
  amazonaws: "/tech/aws.svg",
};

export default function TechStack() {
  return (
    <section className="py-24 bg-blue/10">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 text-center">
        <span className="text-cyan text-xs font-mono-tech tracking-[0.2em] uppercase mb-4 block">
          Tecnologias
        </span>
        <h2 className="text-white text-3xl lg:text-5xl font-bold mb-14">
          Stack de nível enterprise
        </h2>

        <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-10">
          {techStack.map((slug) => (
            <motion.div
              key={slug}
              whileHover={{ y: -6, scale: 1.08 }}
              transition={{ type: "spring", stiffness: 300, damping: 18 }}
              className="flex flex-col items-center gap-3 group"
            >
              <img
                src={LOCAL_ICONS[slug] ?? `https://cdn.simpleicons.org/${slug}/ffffff`}
                alt={LABELS[slug] ?? slug}
                className={`w-10 h-10 opacity-40 group-hover:opacity-100 transition-opacity duration-300 ${
                  LOCAL_ICONS[slug] ? "brightness-0 invert" : ""
                }`}
                loading="lazy"
              />
              <span className="text-xs text-white/40 group-hover:text-white/80 transition-colors duration-300">
                {LABELS[slug] ?? slug}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
